<!-- Header Actions -->
<div class="row">
  <div class="col-3 d-flex justify-content-between">
    <h5>
      Tool ID: <b> {{ this.dataModel.toolId }} </b>
    </h5>
    <h5 *ngIf="dataModel.model?.allowVehicleDetails && vehiclePayload.licensePlate.length">
      License Plate #: <b> {{ vehiclePayload.licensePlate }} </b>
    </h5>
  </div>
  <div class="col" [ngClass]="{ invisible: currentTabId !== 'general' }">
    <div id="header-actions" class="d-flex align-items-end justify-content-end">
      <button
        *ngIf="isAllowed('tools', 'edit')"
        type="button"
        id="tool-setting-add-button"
        class="btn btn-outline-primary"
        (click)="handleTransfer()">
        Save & Transfer
      </button>
      <button class="btn btn-outline-primary" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" *ngIf="isAllowed('tools', 'edit')" (click)="handleSave(false)">Save</button>
      <button class="btn btn-primary" *ngIf="isAllowed('tools', 'edit')" (click)="handleSave(true)">
        Save & Close
      </button>
    </div>
  </div>
</div>
<!-- End Header Actions -->

<form name="form" #toolModelForm="ngForm" novalidate (keydown.enter)="$event.preventDefault()">
  <div class="row">
    <div class="col">
        <div *ngIf="getInventoriedDateString()" class="last-inventoried-section">Last Inventoried: {{ getInventoriedDateString() }}</div>
      <app-nav-tabs [tabs]="tabs" (onClick)="handleTabClick($event)">
        <div id="tab-content" class="tab-content body-content-scroll scrollbar">
          <div id="general" class="tab-pane fade show active" role="tabpanel" aria-labelledby="general-tab">
            <app-card>
              <span class="header">Tool Details</span>
              <div class="row">
                <div class="col-9">
                  <div class="form-row">
                    <!--- Model Image -->
                    <div class="col-2">
                      <div class="form-group">
                        <label>Model Image</label>
                        <ng-container *ngIf="dataModel.model?.thumbnail">
                          <div class="thumbnail">
                            <div class="attachment-block">
                              <img [src]="getImageLink()" (error)="handleImageError()" />
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <!-- End Model Image -->

                    <!-- Model Name, Asset Class, Manufacturer, and Category -->
                    <div class="col-10">
                      <div class="form-row">
                        <div class="form-group form-group-inline col-4">
                          <label for="toolModelId">Description</label>
                          <ng-container>
                            <ng-select
                              id="toolModelId"
                              required
                              [items]="models"
                              required
                              minlength="1"
                              name="toolModelId"
                              #toolModelId
                              bindLabel="name"
                              bindValue="id"
                              [disabled]="!isAllowed('tools', 'edit')"
                              [(ngModel)]="payloadModel.toolModelId"
                              (ngModelChange)="fetchModel($event, true)"
                              [ngModelOptions]="{ standalone: true }">
                                <ng-template ng-label-tmp let-item="item" let-item$="item$"> {{ item.name }} </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <span> {{ item.name }} </span>
                      </ng-template>
                            </ng-select>
                            <div *ngIf="submitted && modelError" class="error">Model is required</div>
                          </ng-container>
                        </div>
                        <div class="form-group col-4">
                          <label for="assetClass">Asset Class</label>
                          <input
                            id="assetClass"
                            class="form-control"
                            type="text"
                            name="assetClass"
                            disabled
                            [value]="dataModel?.model?.category?.assetClass?.name" />
                        </div>

                        <!-- Description -->
                        <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <div class="form-group">
                            <label for="description">Model</label>
                            <textarea
                              id="description"
                              class="form-control flex-grow-1"
                              type="text"
                              name="description"
                              placeholder="Enter description"
                              required
                              #description="ngModel"
                              [disabled]="!isAllowed('tools', 'edit')"
                              [(ngModel)]="payloadModel.description"></textarea>
                            <div
                              *ngIf="submitted && toolModelForm.controls.description.status === 'INVALID'"
                              class="error">
                              Description is required
                            </div>
                          </div>
                        </div>
                        <!--- End Description -->

                        <div class="form-group form-group-inline col-4">
                          <label for="manufacturer">Manufacturer</label>
                          <input
                            id="manufacturer"
                            class="form-control"
                            type="text"
                            name="manufacturer"
                            disabled
                            [value]="dataModel?.model?.manufacturer?.name" />
                        </div>

                        <div class="form-group form-group-inline col-4">
                          <label for="category">Category</label>
                          <input
                            id="category"
                            class="form-control"
                            type="text"
                            name="category"
                            disabled
                            [value]="dataModel?.model?.category?.name" />
                        </div>
                        <div class="form-group form-group-inline col-4">
                          <label for="shopOriginationId">Shop Origination</label>
                          <ng-select
                            class="shop-custom"
                            required
                            [items]="shopLocations"
                            [closeOnSelect]="true"
                            [searchable]="true"
                            bindValue="id"
                            placeholder="Select Shop"
                            bindLabel="name"
                            [clearable]="false"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="payloadModel.shopOriginationId">
                          </ng-select>
                          <div *ngIf="submitted && shopOriginationIdError" class="error">
                            Shop Origination is required
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Model Name, Asset Class, Manufacturer, and Category -->
                  </div>
                </div>

                <div class="col-3">
                  <div class="row">
                    <!-- Notes -->
                    <div class="form-group form-group-inline col-12">
                      <label for="notes">Notes</label>
                      <textarea
                        id="notes"
                        class="form-control"
                        type="text"
                        name="notes"
                        placeholder="Enter general notes"
                        rows="2"
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="payloadModel.notes"></textarea>
                    </div>
                    <!-- End Notes -->
                  </div>
                  <!-- Asset ID# -->
                    <div class="form-group form-group-inline col-12 p-0">
                      <label for="assetId">Asset ID#</label>
                      <input
                        id="assetId"
                        class="form-control"
                        type="text"
                        name="assetId"
                        placeholder="Asset ID#"
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="payloadModel.assetId" />
                    </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <!-- Weekly Maintenance -->
                    <div [ngClass]="payloadModel.inspectionRequired ? 'col-4' : 'col-6'">
                      <app-service-prompt
                        id="servicePromptMaint"
                        name="maintenanceData"
                        #maintenanceRequired
                        label="Does this model require weekly maintenance?"
                        [serviceInfo]="maintenanceData"
                        [datePrompt]="false"
                        [required]="dataModel?.model?.maintenanceRequired"
                        [attachmentData]="dataModel?.model.maintenance"
                        (upload)="handleUploadThumbnail($event, 'maintenance', 'tool_models', true)"
                        (update)="updatePayload('maintenanceRequired', $event)"
                        (delete)="handleDelete($event, 'maintenance')">
                      </app-service-prompt>
                    </div>
                    <!-- End Weekly Maintenance -->

                    <!-- Annual Inspection -->
                    <div [ngClass]="payloadModel?.inspectionRequired ? 'col-4' : 'col-6'">
                      <app-service-prompt
                        id="servicePromptInspect"
                        name="inspectionData"
                        #inspectionRequired
                        label="Does this model require annual inspection?"
                        [serviceInfo]="inspectionData"
                        [datePrompt]="false"
                        [required]="dataModel?.model?.inspectionRequired"
                        [attachmentData]="dataModel?.model?.inspection"
                        (upload)="handleUploadThumbnail($event, 'inspection', 'tool_models', true)"
                        (update)="updatePayload('inspectionRequired', $event)"
                        (delete)="handleDelete($event, 'inspection')"></app-service-prompt>
                    </div>
                    <!-- End Annual Inspection -->

                    <!-- Annual Inspection Date -->
                    <div *ngIf="payloadModel?.inspectionRequired" class="col-4">
                      <label for="inspectionDate">Inspection Date</label>
                      <div class="input-group mb-3">
                        <input
                          tabindex="6"
                          id="inspectionDate"
                          class="form-control datepicker"
                          type="text"
                          name="inspectionDate"
                          placeholder="Select Inspection Date"
                          mask="XX/XX"
                          autocomplete="off"
                          #inspectionDate
                          [(ngModel)]="payloadModel.inspectionDate"
                          (mousedown)="loadDatePicker()"
                          (focus)="setPayload('inspectionDate', inspectionDate.value)" />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <i class="far fa-calendar-alt"></i>
                          </span>
                        </div>
                        <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                          <input
                            class="start_date"
                            type="text"
                            name="start_date"
                            (blur)="setPayload('inspectionDate', inspectionDate.value)" />
                        </div>
                      </div>
                    </div>
                    <!-- End Annual Inspection Date -->
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-row">
                    <!-- Model Year -->
                    <div class="form-group form-group-inline col-3">
                      <label for="modelYear">Model Year</label>
                      <input
                        id="modelYear"
                        class="form-control"
                        type="text"
                        name="modelYear"
                        disabled
                        [value]="dataModel?.model?.modelYear" />
                    </div>
                    <!-- End Model Year -->

                    <!-- Initial Mileage -->
                    <div class="form-group form-group-inline col-3">
                      <label for="initialMileageHours">Initial Mileage / Meter</label>
                      <input
                        id="initialMileageHours"
                        class="form-control"
                        type="number"
                        placeholder="Enter model year"
                        name="initialMileageHours"
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="payloadModel.initialMileageHours" />
                    </div>
                    <!-- End Initial Mileage -->

                    <!-- Serial Number -->
                    <div class="form-group form-group-inline col-3">
                      <label for="serialNumber">Serial/VIN#</label>
                      <input
                        id="serialNumber"
                        class="form-control"
                        type="text"
                        name="serialNumber"
                        placeholder="Serial/VIN#"
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="payloadModel.serialNumber" />
                    </div>

                    <div class="form-group form-group-inline col-3">
                      <label for="lastMileage">Last Mileage/Meter Reading</label>
                      <input
                        id="lastMileage"
                        class="form-control"
                        type="text"
                        (keypress)="validateNumber($event)"
                        pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]"
                        name="lastMileage"
                        placeholder="Last Mileage/Meter Reading"
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="payloadModel.lastMileageHours" />
                    </div>
                    <!-- End Serial Number -->
                  </div>
                </div>
              </div>
            </app-card>

            <!-- Assignment & Inventory -->
            <app-card>
              <span class="header d-flex justify-content-between">
                <span>Assignment & Inventory</span>
              </span>
              <div class="col">
                <div class="form-row">
                  <div class="form-group form-group-inline col-3">
                    <label for="assignmentStatus">Assignment Status</label>
                    <input
                      id="assignmentStatus"
                      class="form-control"
                      type="text"
                      name="assignmentStatus"
                      disabled
                      [value]="payloadModel?.assignmentType" />
                  </div>
                  <div *ngIf="dataModel.assignment?.assignedTo" class="form-group form-group-inline col-3">
                    <label for="assignedTo">Assigned To</label>
                    <input
                      id="assignedTo"
                      class="form-control"
                      type="text"
                      name="assignedTo"
                      disabled
                      [value]="dataModel.assignment?.assignedTo" />
                  </div>
                  <div *ngIf="dataModel.assignment?.job" class="form-group form-group-inline col-3">
                    <label for="assignedJob">Job</label>
                    <input
                      id="assignedJob"
                      class="form-control"
                      type="text"
                      name="assignedTo"
                      disabled
                      [value]="dataModel.assignment?.job?.alias" />
                  </div>
                  <div
                    *ngIf="dataModel.assignment?.employee && !dataModel.assignment?.assignedTo"
                    class="form-group form-group-inline col-3">
                    <label for="assignedTo">Assigned To</label>
                    <input
                      id="assignedTo"
                      class="form-control"
                      type="text"
                      name="assignedTo"
                      disabled
                      [value]="dataModel.assignment?.employee?.employeeAlias" />
                  </div>
                  <div *ngIf="dataModel?.assignment?.owner" class="form-group form-group-inline col-3">
                    <label for="assingedOwner">Owner</label>
                    <input
                      id="assingedOwner"
                      class="form-control"
                      type="text"
                      name="assingedOwner"
                      disabled
                      [value]="dataModel.assignment?.owner?.owner_name" />
                  </div>
                  <div *ngIf="dataModel?.assignment?.facility" class="form-group form-group-inline col-3">
                    <label for="Facility">Facility</label>
                    <input
                      id="Facility"
                      class="form-control"
                      type="text"
                      name="Facility"
                      disabled
                      [value]="dataModel?.assignment?.facility?.facility_name" />
                  </div>
                  <div *ngIf="dataModel?.assignment?.job" class="form-group form-group-inline col-3">
                    <label for="responsibleParty">Foreman</label>
                    <input
                      id="responsibleParty"
                      class="form-control"
                      type="text"
                      name="responsibleParty"
                      disabled
                      [value]="dataModel?.assignment?.job?.foreman" />
                  </div>
                  <div *ngIf="dataModel?.assignment?.responsibleParty" class="form-group form-group-inline col-3">
                    <label for="responsibleParty">Responsible Party</label>
                    <input
                      id="responsibleParty"
                      class="form-control"
                      type="text"
                      name="responsibleParty"
                      disabled
                      [value]="dataModel?.assignment?.responsibleParty.employeeAlias" />
                  </div>
                  <div *ngIf="dataModel?.assignment?.vendor" class="form-group form-group-inline col-3">
                    <label for="responsibleParty">Vendor Name</label>
                    <input
                      id="responsibleParty"
                      class="form-control"
                      type="text"
                      name="responsibleParty"
                      disabled
                      [value]="dataModel?.assignment?.vendor?.companyName" />
                  </div>

                  <!-- || (dataModel?.assignment?.shopLocation == null && dataModel?.assignment?.assignedTo)) -->
                  <div
                    *ngIf="dataModel?.assignment?.typeId === 3 && dataModel?.assignment?.shopLocation"
                    class="form-group form-group-inline col-3">
                    <label for="shopLocation">Shop location</label>
                    <ng-container *ngIf="dataModel?.assignment?.shopLocation">
                      <input
                        id="shopLocation"
                        class="form-control"
                        type="text"
                        name="shopLocation"
                        disabled
                        [value]="dataModel?.assignment?.shopLocation?.name" />
                    </ng-container>
                    <!-- <ng-container
                      *ngIf="dataModel?.assignment?.shopLocation == null && dataModel?.assignment?.assignedTo">
                      <input
                        id="shopLocation"
                        class="form-control"
                        type="text"
                        name="shopLocation"
                        disabled
                        [value]="dataModel?.assignment?.assignedTo" />
                    </ng-container> -->
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="assignedNotes">Transfer Notes</label>
                    <textarea
                      id="assignedNotes"
                      class="form-control"
                      name="assignedNotes"
                      rows="1"
                      disabled
                      [value]="dataModel.assignment?.notes">
                    </textarea>
                  </div>
                  <div *ngIf="dataModel?.assignment?.assignedDate" class="form-group form-group-inline col-3">
                    <label for="assignedDate">Assigned Date</label>
                    <input
                      id="assignedDate"
                      class="form-control"
                      type="text"
                      name="assignedDate"
                      disabled
                      [value]="dataModel.assignment?.assignedDate" />
                  </div>
                  <div *ngIf="dataModel?.assignment?.department" class="form-group form-group-inline col-3">
                    <label for="department">Department</label>
                    <input
                      id="department"
                      class="form-control"
                      type="text"
                      name="department"
                      placeholder="Department"
                      disabled
                      [value]="dataModel.assignment?.department?.name" />
                  </div>
                </div>
              </div>
            </app-card>
            <!-- End Assignment & Inventory -->

            <!-- Purchase Details -->
            <app-card *ngIf="isAllowed('tools', 'edit')">
              <span class="header">Purchase Details</span>
              <div class="col">
                <div class="form-row">
                  <!-- Purchase Date -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchDate">Purchase Date</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="purchDate"
                        class="form-control datepicker"
                        type="text"
                        name="purchDate"
                        placeholder="Select Purchase Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #start_date
                        [(ngModel)]="payloadModel.purchDate"
                        (focus)="setPayload('purchDate', start_date.value)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="start_date"
                          (blur)="setPayload('purchDate', start_date.value)" />
                      </div>
                    </div>
                  </div>
                  <!-- End Purchase Date -->

                  <!-- PO Number -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchPoNumber">PO Number</label>
                    <input
                      id="purchPoNumber"
                      class="form-control"
                      type="text"
                      name="purchPoNumber"
                      [(ngModel)]="payloadModel.purchPoNumber" />
                  </div>
                  <!-- End PO Number -->

                  <!-- Purchase Price -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchPrice">Purchase Price</label>
                    <input
                      id="purchPrice"
                      class="form-control"
                      (blur)="formatToCurrency('purchPrice', $event)"
                      type="text"
                      name="purchPrice"
                      [(ngModel)]="formattedValue['purchPrice']" />
                  </div>
                  <!-- End Purchase Price -->

                  <!-- Purchase By -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchBy">Purchased By</label>
                    <select
                      id="purchBy"
                      class="form-control select2 generalLocked"
                      name="purchBy"
                      #purchBy
                      [(ngModel)]="payloadModel.purchBy"
                      (ngModelChange)="setPayload('purchBy', purchBy.value)"
                      [ngModelOptions]="{ standalone: true }">
                      <option selected="selected" disabled value="null">Employees</option>
                      <option *ngFor="let employee of employees" [value]="employee.id">
                        {{
                          employee.employee_alias
                            ? employee.employee_alias
                            : employee.first_name +
                              '
                        ' +
                              employee.last_name
                        }}
                      </option>
                    </select>
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input
                        type="text"
                        name="purchBy"
                        [(ngModel)]="payloadModel.purchBy"
                        (ngModelChange)="setPayload('purchBy', purchBy.value)"
                        [ngModelOptions]="{ standalone: true }"
                        (blur)="setPayload('purchBy', purchBy.value)" />
                    </div>
                  </div>
                  <!-- End Purchased By -->
                </div>
                <div class="form-row">
                  <!-- Warranty Expiration -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchWarrantyExpiration">Warranty Expiration</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="purchWarrantyExpiration"
                        class="form-control datepicker"
                        type="text"
                        name="purchWarrantyExpiration"
                        placeholder="Select Start Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #purchWarrantyExpiration
                        [(ngModel)]="payloadModel.purchWarrantyExpiration"
                        (focus)="setPayload('purchWarrantyExpiration', purchWarrantyExpiration.value)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="start_date"
                          (blur)="setPayload('purchWarrantyExpiration', purchWarrantyExpiration.value)" />
                      </div>
                    </div>
                  </div>
                  <!-- End Warranty Expiration -->

                  <!-- Vendor -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchVendor">Vendor</label>
                    <ng-select
                      class="select-dropdown"
                      id="purchVendor"
                      #purchVendor
                      [items]="vendors"
                      bindLabel="companyName"
                      bindValue="id"
                      [multiple]="false"
                      [searchable]="true"
                      [virtualScroll]="true"
                      placeholder="Select Vendor"
                      [(ngModel)]="payloadModel.purchVendor"
                      (ngModelChange)="setPayload('purchVendor', payloadModel.purchVendor)"
                      [ngModelOptions]="{ standalone: true }">
                      <ng-template ng-label-tmp let-item="item" let-item$="item$"> {{ item.companyName }} </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <span> {{ item.companyName }} </span>
                      </ng-template>
                    </ng-select>
                  </div>
                  <!-- End Vendor -->

                  <!-- Purchase Notes -->
                  <div class="form-group form-group-inline col-3">
                    <label for="purchNote">Purchase Notes</label>
                    <textarea
                      id="purchNote"
                      class="form-control flex-grow-1"
                      type="text"
                      name="purchNote"
                      placeholder="Enter description"
                      rows="4"
                      [(ngModel)]="payloadModel.purchNote"></textarea>
                  </div>
                  <!-- End Purchase Notes -->
                </div>
              </div>
            </app-card>
            <!-- End Purchase Details -->

            <app-card [hidden]="!dataModel.model?.allowVehicleDetails">
              <span class="header">Vehicle Information</span>
              <div class="col">
                <div class="form-row">
                  <div class="form-group form-group-inline col-3">
                    <label for="licensePlate">License Plate #</label>
                    <input
                      id="licensePlate"
                      class="form-control"
                      type="text"
                      name="licensePlate"
                      [(ngModel)]="vehiclePayload.licensePlate"
                      [disabled]="!isAllowed('tools', 'edit')" />
                    <div *ngIf="submitted && getErrorMsg('license_plate')" class="error">
                      {{ getErrorMsg('license_plate') }}
                    </div>
                  </div>
                  <div class="form-group form-group-inline col-2">
                    <label>Fleet Vehicle #</label>
                    <input
                      id="fleetVehicle"
                      class="form-control"
                      type="text"
                      name="fleetVehicle"
                      [(ngModel)]="vehiclePayload.fleetVehicleNumber"
                      maxlength="3" />
                    <div *ngIf="submitted && getErrorMsg('fleet_vehicle_number')" class="error">
                      {{ getErrorMsg('fleet_vehicle_number') }}
                    </div>
                  </div>
                  <div class="form-group form-group-inline col-1">
                    <label>State</label>
                    <select
                      id="tool-search-input"
                      class="form-control"
                      name="state"
                      [(ngModel)]="vehiclePayload.state"
                      [disabled]="!isAllowed('tools', 'edit')">
                      <option *ngFor="let item of statesData" value="{{ item.abbreviation }}">
                        {{ item.abbreviation }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="warrantyExpirationDate"><b>Full Warranty</b> Expiration Date</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="warrantyExpirationDate"
                        class="form-control datepicker"
                        type="text"
                        name="warrantyExpirationDate"
                        placeholder="Select Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #warrantyExpirationDate
                        [(ngModel)]="vehiclePayload.warrantyExpirationDate"
                        [disabled]="!isAllowed('tools', 'edit')"
                        (focus)="setVehiclePayload('warrantyExpirationDate', warrantyExpirationDate.value)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="warrantyExpirationDate"
                          (blur)="setVehiclePayload('warrantyExpirationDate', warrantyExpirationDate.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="warrantyExpirationMileage"><b>Warranty </b> Mileage Expiration</label>
                    <input
                      id="warrantyExpirationMileage"
                      class="form-control"
                      type="text"
                      name="warrantyExpirationMileage"
                      pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]"
                      (blur)="formatToCommaSeperatedNumber('warrantyExpirationMileage', $event)"
                      [(ngModel)]="formattedValue['warrantyExpirationMileage']"
                      [disabled]="!isAllowed('tools', 'edit')" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group form-group-inline col-3">
                    <label for="tabExpirationDate">Tab Expiration Date</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="tabExpirationDate"
                        class="form-control datepicker"
                        type="text"
                        name="tabExpirationDate"
                        placeholder="Select Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #tabExpirationDate
                        [(ngModel)]="vehiclePayload.tabExpirationDate"
                        (focus)="setVehiclePayload('tabExpirationDate', tabExpirationDate.value)"
                        [disabled]="!isAllowed('tools', 'edit')" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="tabExpirationDate"
                          (blur)="setVehiclePayload('tabExpirationDate', tabExpirationDate.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="tabRenewalAmount">Tab Renewal Amount</label>
                    <input
                      id="tabRenewalAmount"
                      class="form-control"
                      type="text"
                      name="tabRenewalAmount"
                      pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]"
                      (blur)="formatToCurrencyGeneric('tabRenewalAmount', $event)"
                      [(ngModel)]="formattedValue['tabRenewalAmount']"
                      [disabled]="!isAllowed('tools', 'edit')" />
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="powertrainExpirationDate"><b>Powertrain Warranty</b> Expiration Date</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="powertrainExpirationDate"
                        class="form-control datepicker"
                        type="text"
                        name="powertrainExpirationDate"
                        placeholder="Select Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #powertrainExpirationDate
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="vehiclePayload.powertrainExpirationDate"
                        (focus)="setVehiclePayload('powertrainExpirationDate', powertrainExpirationDate.value)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="powertrainExpirationDate"
                          (blur)="setVehiclePayload('powertrainExpirationDate', powertrainExpirationDate.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="powertrainExpirationMileage"><b>Powertrain </b>Mileage Expiration</label>
                    <input
                      id="powertrainExpirationMileage"
                      class="form-control"
                      type="text"
                      name="powertrainExpirationMileage"
                      [disabled]="!isAllowed('tools', 'edit')"
                      pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]"
                      (blur)="formatToCommaSeperatedNumber('powertrainExpirationMileage', $event)"
                      [(ngModel)]="formattedValue['powertrainExpirationMileage']" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group form-group-inline col-3">
                    <app-service-prompt
                      id="serviceHasInsurance"
                      name="maintenanceData"
                      label="Company Insurance"
                      [serviceInfo]=""
                      [datePrompt]="false"
                      [required]="vehiclePayload.hasInsurance"
                      (update)="updateVehiclePayload('hasInsurance', $event)"
                      [disable]="!isAllowed('tools', 'edit')">
                    </app-service-prompt>
                  </div>

                  <div class="form-group form-group-inline col-3">
                    <label for="insuranceDate">Insurance Date</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="insuranceDate"
                        class="form-control datepicker"
                        type="text"
                        name="insuranceDate"
                        placeholder="Select Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #insuranceDate
                        [(ngModel)]="vehiclePayload.insuranceDate"
                        (focus)="setVehiclePayload('insuranceDate', insuranceDate.value)"
                        [disabled]="!isAllowed('tools', 'edit')" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="insuranceDate"
                          (blur)="setVehiclePayload('insuranceDate', insuranceDate.value)" />
                      </div>
                    </div>
                  </div>

                  <div class="form-group form-group-inline col-3">
                    <label for="emissionsExpirationDate"><b>Emission Warranty</b> Expiration Date</label>
                    <div class="input-group mb-3">
                      <input
                        tabindex="6"
                        id="emissionsExpirationDate"
                        class="form-control datepicker"
                        type="text"
                        name="emissionsExpirationDate"
                        placeholder="Select Date"
                        mask="XX/XX/XXXX"
                        autocomplete="off"
                        #emissionsExpirationDate
                        [disabled]="!isAllowed('tools', 'edit')"
                        [(ngModel)]="vehiclePayload.emissionsExpirationDate"
                        (focus)="setVehiclePayload('emissionsExpirationDate', emissionsExpirationDate.value)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="far fa-calendar-alt"></i>
                        </span>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          class="start_date"
                          type="text"
                          name="emissionsExpirationDate"
                          (blur)="setVehiclePayload('emissionsExpirationDate', emissionsExpirationDate.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-inline col-3">
                    <label for="emissionsExpirationMileage"><b>Emissions </b>Mileage Expiration</label>
                    <input
                      id="emissionsExpirationMileage"
                      class="form-control"
                      type="text"
                      name="emissionsExpirationMileage"
                      pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]"
                      (blur)="formatToCommaSeperatedNumber('emissionsExpirationMileage', $event)"
                      [(ngModel)]="formattedValue['emissionsExpirationMileage']"
                      [disabled]="!isAllowed('tools', 'edit')" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group form-group-inline col-3">
                    <label for="notes">Vehicle Notes</label>
                    <textarea
                      id="vehicleNotes"
                      class="form-control flex-grow-1"
                      type="text"
                      name="vehicleNotes"
                      placeholder="Enter description"
                      rows="4"
                      [disabled]="!isAllowed('tools', 'edit')"
                      [(ngModel)]="vehiclePayload.notes"></textarea>
                  </div>
                </div>
              </div>
            </app-card>

            <div class="row">
              <div class="col-7">
                <!-- Rental Details -->
                <app-tool-rental-details
                  [dataModel]="dataModel.model"
                  [disabled]="true"
                  [formattedValue]="dataModel.model"></app-tool-rental-details>
                <!-- End Rental Details -->
              </div>
              <div class="col-5">
                <!-- Alert -->
                <app-switch-card
                  label="Alert Code"
                  [allowChanges]="isAllowed('tools', 'edit')"
                  [enabled]="dataModel.alert?.enabled"
                  [message]="dataModel.alert?.message"
                  (action)="handleAlertAction($event)"></app-switch-card>
                <!-- End Alert -->
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <!-- Images -->
                <app-attachments-card
                  label="Images"
                  key="images"
                  attachmentType="image"
                  [source]="dataType"
                  parentType="tools"
                  [allowChanges]="isAllowed('tools', 'edit')"
                  [parentId]="dataModel.id"
                  [attachments]="payloadModel.images"
                  (uploadAction)="handleUploadAttachment($event)"
                  (deleteAction)="handleDeleteAttachment($event)"></app-attachments-card>
                <!-- End Images -->
              </div>
              <div class="col-5">
                <app-attachments-card
                  label="Documents"
                  key="documents"
                  attachmentType="document"
                  [source]="dataType"
                  parentType="tools"
                  [allowChanges]="isAllowed('tools', 'edit')"
                  [parentId]="dataModel.id"
                  [attachments]="payloadModel.documents"
                  (uploadAction)="handleUploadAttachment($event)"
                  (deleteAction)="handleDeleteAttachment($event)"></app-attachments-card>
              </div>
            </div>
          </div>

          <!-- History -->
          <div id="history" class="tab-pane fade" role="tabpanel" aria-labelledby="history-tab">
            <app-tool-history></app-tool-history>
          </div>
          <!-- End History -->
        </div>
      </app-nav-tabs>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="row mb-4 mt-4" [ngClass]="{ invisible: currentTabId !== 'general' }">
    <div class="col">
      <div id="header-actions" class="d-flex align-items-end justify-content-end">
        <button class="btn btn-outline-primary" (click)="handleCancel()">Cancel</button>
        <button *ngIf="isAllowed('tools', 'edit')" (click)="handleSave(false)" class="btn btn-primary">Save</button>
        <button *ngIf="isAllowed('tools', 'edit')" (click)="handleSave(true)" class="btn btn-primary">
          Save & Close
        </button>
      </div>
    </div>
  </div>
  <!-- End Footer Actions -->
</form>

<!-- model dialog prompt -->
<app-dialog id="delete-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">{{ dialogRecord.actionName }} {{ dialogRecord?.data?.toolId }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'delete'">
      Are you sure you want to {{ dialogRecord.actionName | lowercase }} <b>{{ dialogRecord?.name }}</b
      >?
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary" id="delete-dialog_btn-ok">Continue</button>
  </span>
</app-dialog>

<app-tool-transfer></app-tool-transfer>
